import React from "react";
import styles from "./style.module.scss";
import TimingDataManager from "../../../components/DataManagers/TimingDataManager";
import V2LiveViewer from "../../../components/Timing/V2LiveViewer";
import AuthenticatedLayout from "../../../components/Layout/authenticatedLayout";

function V2LivePage() {
  return (
    <AuthenticatedLayout title={"V2 Live"} showJaguarLogo={false}>
      <TimingDataManager />
      <div className={styles.container}>
        <V2LiveViewer />
      </div>
    </AuthenticatedLayout>
  );
}

export default V2LivePage;
